export const ScannerTypeConstant :any = {
  RFQ: 'RFQ',
  LOCATION: 'LOCATION',
  ORDER_NOT_IN_PICKING: 'ORDER_NOT_IN_PICKING',
  ORDER_SHIPPED: 'ORDER_SHIPPED',
  ORDER_PICKLIST_CREATED: 'ORDER_PICKLIST_CREATED',
  ORDER_PICKLIST_PICKED: 'ORDER_PICKLIST_PICKED',
  UNKNOWN: 'UNKNOWN',
};
